import { render } from "./ValidatorsTable.vue?vue&type=template&id=5d9d514a"
import script from "./ValidatorsTable.vue?vue&type=script&lang=js"
export * from "./ValidatorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Validators/ValidatorsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d9d514a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d9d514a', __exports__)) {
    api.reload('5d9d514a', __exports__)
  }
  
  module.hot.accept("./ValidatorsTable.vue?vue&type=template&id=5d9d514a", () => {
    api.rerender('5d9d514a', render)
  })

}


export default __exports__